import React from 'react';
import Head from 'expo-router/head';
import { StaticContentScreen } from '@components/common';

const termsSections = [
  {
    title: 'Acceptance of Terms',
    body: 'By accessing and using the Redi application, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the application.',
  },
  {
    title: 'Use of Service',
    body: 'Redi is a platform for documenting and sharing catastrophe risk reduction efforts within your community. You agree to use the service only for its intended purpose and in compliance with all applicable laws.',
  },
  {
    title: 'User Content',
    body: 'You retain ownership of content you post to Redi, including photos and text. By posting content, you grant Redi a non-exclusive license to display and share your content within the platform for its intended purpose.',
  },
  {
    title: 'Privacy',
    body: 'Your use of Redi is also governed by our Privacy Policy. Please review it to understand how we collect, use, and protect your information.',
  },
  {
    title: 'Limitation of Liability',
    body: 'Redi is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the service. Redi does not guarantee insurance outcomes based on documented risk reduction efforts.',
  },
  {
    title: 'Changes to Terms',
    body: 'We may update these terms from time to time. Continued use of Redi after changes constitutes acceptance of the updated terms.',
  },
];

export default function TermsScreen() {
  return (
    <>
      <Head>
        <title>Terms of Service - Redi</title>
      </Head>
      <StaticContentScreen
        title="Terms of Service"
        sections={termsSections}
        footerText="Last updated: April 2026"
      />
    </>
  );
}
